import * as types from './constants';

// Check Assignment Balance
export const checkAssignmentBalanceRequest = data => (
  { type: types.CHECK_ASSIGNMENT_BALANCE_REQUEST, payload: data }
);

export const checkAssignmentBalanceDone = data => (
  { type: types.CHECK_ASSIGNMENT_BALANCE_DONE, payload: data }
);

export const checkAssignmentBalanceFailed = errors => (
  { type: types.CHECK_ASSIGNMENT_BALANCE_FAILED, payload: errors }
);

export const checkAssignmentBalanceClearErrors = prop => (
  { type: types.CHECK_ASSIGNMENT_BALANCE_CLEAR_ERRORS, payload: prop }
);

export const checkAssignmentBalanceReset = () => (
  { type: types.CHECK_ASSIGNMENT_BALANCE_RESET }
);